import React, { useRef, useEffect } from "react";
import * as echarts from "echarts/core";
import { GaugeChart } from "echarts/charts";
import { TitleComponent, TooltipComponent } from "echarts/components";
import { CanvasRenderer } from "echarts/renderers";

echarts.use([TitleComponent, TooltipComponent, GaugeChart, CanvasRenderer]);

const EChartsGaugeChart = ({ options, style, height = "300px" }) => {
  const chartRef = useRef(null);

  useEffect(() => {
    let chartInstance = null;
    if (chartRef.current) {
      chartInstance = echarts.init(chartRef.current);
      chartInstance.setOption(options);
    }

    const resizeChart = () => {
      chartInstance?.resize();
    };

    window.addEventListener("resize", resizeChart);

    return () => {
      chartInstance?.dispose();
      window.removeEventListener("resize", resizeChart);
    };
  }, [options]);

  return <div ref={chartRef} style={{ width: "100%", height, ...style }} />;
};

export default EChartsGaugeChart;
